<template>
  <!-- 公共底部 tab：我的签到、新建签到、审核通知、个人中心四个入口统一从这里维护。 -->
  <nav class="checkin-bottom-tab" aria-label="底部导航">
    <button type="button" class="checkin-bottom-tab__item" :class="activeClass('myCheckin')" @click="goRoute('myCheckin')">
      <img class="checkin-bottom-tab__icon" :src="active === 'myCheckin' ? tabIcons.signSelected : tabIcons.sign" alt="我的签到" />
      <span class="checkin-bottom-tab__text">我的签到</span>
    </button>
    <button type="button" class="checkin-bottom-tab__item" :class="activeClass('create')" @click="goRoute('createDefault')">
      <img class="checkin-bottom-tab__icon" :src="active === 'create' ? tabIcons.createSelected : tabIcons.create" alt="新建签到" />
      <span class="checkin-bottom-tab__text">新建签到</span>
    </button>
    <button type="button" class="checkin-bottom-tab__item" :class="activeClass('notice')" @click="goRoute('notice')">
      <span class="checkin-bottom-tab__notice">
        <img class="checkin-bottom-tab__icon" :src="active === 'notice' ? tabIcons.noticeSelected : tabIcons.notice" alt="审核通知" />
        <span v-if="normalizedNoticeBadge > 0" class="checkin-bottom-tab__badge">{{ normalizedNoticeBadge }}</span>
      </span>
      <span class="checkin-bottom-tab__text">审核通知</span>
    </button>
    <button type="button" class="checkin-bottom-tab__item" :class="activeClass('personal')" @click="goRoute('personal')">
      <img class="checkin-bottom-tab__icon" :src="active === 'personal' ? tabIcons.userSelected : tabIcons.user" alt="个人中心" />
      <span class="checkin-bottom-tab__text">个人中心</span>
    </button>
  </nav>
</template>

<script>
/**
 * 小小签到底部四栏导航组件。
 *
 * @description 页面只负责声明当前激活 tab，组件统一处理四个底部入口的 H5 路由跳转。
 */
export default {
  name: 'CheckinBottomTab',
  props: {
    /**
     * 当前高亮的 tab 名称，可选值：myCheckin、create、notice、personal。
     */
    active: {
      type: String,
      default: '',
    },
    /**
     * 审核通知角标数量；暂无接口时按截图默认展示 4。
     */
    noticeBadge: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      // 底部 tab 图标集中管理，保证所有页面视觉一致。
      tabIcons: {
        sign: require('@/assets/tab_footer/tab_sign.png'),
        signSelected: require('@/assets/tab_footer/tab_sign_selected.png'),
        create: require('@/assets/tab_footer/tab_create.png'),
        createSelected: require('@/assets/tab_footer/tab_create_selected.png'),
        notice: require('@/assets/tab_footer/tab_notice.png'),
        noticeSelected: require('@/assets/tab_footer/tab_notice_selected.png'),
        user: require('@/assets/tab_footer/tab_user.png'),
        userSelected: require('@/assets/tab_footer/tab_user_selected.png'),
      },
    }
  },
  computed: {
    /**
     * 规范化通知角标，防止空值、非数字或负数导致 UI 异常。
     *
     * @returns {number} 非负整数角标。
     */
    normalizedNoticeBadge() {
      const value = Number(this.noticeBadge || 0)
      if (!Number.isFinite(value) || value <= 0) {
        return 0
      }
      return Math.min(Math.floor(value), 99)
    },
  },
  methods: {
    /**
     * 根据当前激活 tab 生成高亮类名。
     *
     * @param {string} tabName tab 名称。
     * @returns {Object} Vue class 绑定对象。
     */
    activeClass(tabName) {
      return {
        'checkin-bottom-tab__item--active': this.active === tabName,
      }
    },
    /**
     * 跳转到指定 H5 路由，同一路由重复点击时不触发导航异常。
     *
     * @param {string} routeName 目标路由名称。
     * @returns {void}
     */
    goRoute(routeName) {
      if (!routeName || (this.$route && this.$route.name === routeName)) {
        return
      }
      this.$router.push({ name: routeName }).catch(() => {})
    },
  },
}
</script>

<style scoped lang="scss">
.checkin-bottom-tab {
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 20;
  display: flex;
  width: 100%;
  max-width: 500px;
  height: 60px;
  padding-bottom: env(safe-area-inset-bottom);
  border-top: 1px solid #ececec;
  background: #fff;
  box-sizing: content-box;
  transform: translateX(-50%);
}

.checkin-bottom-tab__item {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 0;
  border: 0;
  outline: 0;
  color: #333;
  font-family: inherit;
  font-size: 12px;
  line-height: 1.2;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.checkin-bottom-tab__item--active {
  color: #09f;
}

.checkin-bottom-tab__icon {
  display: block;
  width: 26px;
  height: 26px;
  margin-bottom: 4px;
}

.checkin-bottom-tab__text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.checkin-bottom-tab__notice {
  position: relative;
  display: block;
}

.checkin-bottom-tab__badge {
  position: absolute;
  top: -8px;
  right: -12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  background: #ff4d4f;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/CheckinBottomTab.vue